import React from "react";
import { Link } from "react-router-dom";

export default class Hero extends React.Component {
  componentDidMount() {
    const $ = window.$;

    if ($(".slider-carousel").length) {
      $(".slider-carousel").owlCarousel({
        animateOut: "fadeOut",
        animateIn: "fadeIn",
        loop: true,
        margin: 0,
        nav: false,
        singleItem: true,
        smartSpeed: 500,
        autoplay: true,
        autoplayTimeout: 6000,
        navText: [
          '<span class="icon-right-arrow"></span>',
          '<span class="icon-right-arrow"></span>',
        ],
        responsive: {
          0: {
            items: 1,
          },
          600: {
            items: 1,
          },
          1024: {
            items: 1,
          },
        },
      });
    }
  }
  render() {
    let publicUrl = process.env.PUBLIC_URL + "/";
    return (
      <>
        <section className="slider-one-sec style3">
          <div className="slider-carousel owl-carousel owl-theme">
            {/* Start Slider One Single */}
            <div className="slider-one__single">
              <div
                className="image-layer"
                style={{
                  backgroundImage:
                    "url(" +
                    publicUrl +
                    "assets/images/update1.0/slider-v1-img4.jpg)",
                }}
              ></div>
              <div className="container">
                <div className="row clearfix">
                  <div className="col-xl-12">
                    <div className="slider-one__single-content">
                      <h3>
                        <div className="logo-box">
                          <Link to={process.env.PUBLIC_URL + `/`}>
                            <img
                              src={
                                publicUrl +
                                "assets/images/logo/logo-orange-white-full.png"
                              }
                              alt="Logo"
                            />
                          </Link>
                        </div>
                      </h3>
                      <h2>
                        Gradimo zajedno, <br />
                        od temelja do krova.
                      </h2>
                      <p>
                        Vaša vizija, naša izgradnja – od prvog temelja do
                        završnog sloja
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* End Slider One Single */}
          </div>
        </section>
      </>
    );
  }
}
